// extracted by mini-css-extract-plugin
export default {"buttonPrincipal":"ButtonPrincipal_buttonPrincipal__yVwzU","lg":"ButtonPrincipal_lg__JNQbY"};